import.meta.glob(['../img/**',]);
// resources/js/app.js
import.meta.glob('../img/**/*', { eager: true });

import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';



// import './scripts/select.js';
// import './helpers/tailwind_sizes.js';
import './scripts/accordion.js';
// import './scripts/sliders.js';

import './scripts/navigation.js';

import './scripts/animations.js'
// import './scripts/contact-form.js';
// import '@awesome.me/webawesome/dist/components/comparison/comparison.js';



// if (document.querySelectorAll('.js-player').length > 0){
//     import('./scripts/custom-video-player.js').then(({initPlyr}) => initPlyr())
// }

// window.addEventListener('load', () => {
//     if (document.querySelectorAll('.block-testimonials').length > 0) {
//         import('./scripts/testimonials.js').then(({initTestimonialsSlider}) => initTestimonialsSlider());
//     }
// });

function setScrollbarWidth() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth + 1;// added + 1 so if clientWidth is with . something it will still calculate properly.
    document.documentElement.style.setProperty('--scrollbar-size', `${scrollbarWidth}px`);
}

setScrollbarWidth()

// alert('hellow here')

// const footerCookieYesSettingsCTA = document.querySelector('footer .cky-banner-element');
// footerCookieYesSettingsCTA.addEventListener('click',(e)=>{
//     e.preventDefault();
// })

const accordions = document.querySelectorAll('[data-accordion]');
const desktop = window.matchMedia('(min-width: 1024px)');

accordions.forEach((acc) => {
    const btn = acc.querySelector('[data-accordion-toggle]');
    btn.addEventListener('click', () => {
        const open = acc.dataset.open !== 'true';
        acc.dataset.open = open;
        btn.setAttribute('aria-expanded', open);
    });
});

const sync = () => {
    accordions.forEach((acc) => {
        const btn = acc.querySelector('[data-accordion-toggle]');
        if (desktop.matches) {
            btn.setAttribute('aria-expanded', 'true');
            btn.tabIndex = -1;
        } else {
            btn.setAttribute('aria-expanded', acc.dataset.open === 'true');
            btn.removeAttribute('tabindex');
        }
    });
};

desktop.addEventListener('change', sync);
sync();



const infoCardsSlider = document.querySelector('.info-cards-slider');
if (infoCardsSlider){
    const swiper = new Swiper('.info-cards-slider .swiper', {
        modules: [Pagination, Autoplay],
        // Optional parameters
        direction: 'horizontal',
        loop: true,
        spaceBetween: 20,
        breakpoints: {
            320: {
                slidesPerView: 1,
            },

            640: {
                slidesPerView: 2,
            }
        },

        // Navigation arrows
        // navigation: {
        //     nextEl: '.swiper-button-next',
        //     prevEl: '.swiper-button-prev',
        // },

        // If we need pagination
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });
}